<div
  *ngIf="open"
  class="absolute inset-0 z-10 flex justify-end bg-black/20"
  (click)="closed.emit()"
>
  <aside
    class="survey-panel flex flex-col h-full w-[300px] max-w-[85%] bg-white shadow-xl"
    (click)="$event.stopPropagation()"
  >
    <header class="flex items-center justify-between px-4 py-2 border-b-1 border-solid border-gray-200">
      <h3 class="text-base font-bold text-gray-800">{{ title }}</h3>
      <button
        type="button"
        class="bg-transparent border-none text-gray-600 cursor-pointer p-1"
        aria-label="Cerrar"
        (click)="closed.emit()"
      >
        <mat-icon class="mdi mdi-close text-xl" aria-hidden="true"></mat-icon>
      </button>
    </header>

    <!-- <p class="px-5 pt-3 pb-2 text-xs font-semibold tracking-wide uppercase text-gray-500">
      {{ sectionLabel }}
    </p> -->

    <ul class="flex-1 overflow-y-auto px-3 pb-3 flex flex-col gap-1">
      <li *ngFor="let question of questions; let i = index; trackBy: trackByIndex"
      [class.li-q-primary]="i === index"
      >
        <button
          type="button"
          class="w-full flex items-start gap-3 text-left px-3 py-2.5 rounded-lg border-none cursor-pointer bg-transparent hover:bg-gray-100"
          [ngClass]="{ 'bg-primary_super_ultra_light_variant font-bold text-primary': i === index }"
          [attr.aria-current]="i === index ? 'step' : null"
          (click)="pick(i)"
        >
          <mat-icon
            class="mdi mt-0.5 text-xl leading-none flex-none"
            [ngClass]="answeredOf(question) ? 'mdi-check-circle text-green-600' : 'mdi-checkbox-blank-circle-outline text-gray-400'"
            aria-hidden="true"
          ></mat-icon>
          <span class="text-sm leading-snug text-gray-800" [class.text-primary]="i === index" [innerHTML]="labelOf(question)"></span>
        </button>
      </li>
    </ul>

    <footer class="flex items-center gap-4 px-5 py-3 border-t border-solid border-gray-200 text-xs text-gray-700">
      <span class="flex items-center gap-1.5">
        <mat-icon class="mdi mdi-check-circle text-green-600 text-base leading-none" aria-hidden="true"></mat-icon>
        Respondida
      </span>
      <span class="flex items-center gap-1.5">
        <mat-icon class="mdi mdi-checkbox-blank-circle-outline text-gray-400 text-base leading-none" aria-hidden="true"></mat-icon>
        Pendiente
      </span>
    </footer>
  </aside>
</div>
